import React from 'react';
import { Row, Modal } from 'react-bootstrap';
import { makeStyles } from "@material-ui/core/styles";
import Carriers from "../../../Home/Carriers/Carriers";
import "./ProductModal.scss";

const useStyles = makeStyles(theme => ({
    productModalHighlighted: {
        zIndex:'1400'
    }
}));

export default function ProductModal(props) {
    const classes = useStyles();

    const {header, content, mainText} = props.productData;

    return (
        <Modal show={props.productModalShow} className={classes.productModalHighlighted} onHide={props.handleProductModalClose} backdrop={true} size="lg" centered scrollable={true}>
            <Modal.Header className="product hero" closeButton>
              <h1>{header.title}</h1>
              <h2>{header.subtitle}</h2>
              <button onClick={() => props.handleProductModalClose(true)}>{header.button.title}</button>
            </Modal.Header>
            <Modal.Body className="product">
              <p>{mainText}</p>
              <h2>Product Specifications</h2>
              {content.map((c, index) => {
                return <div key={index}>
                          {c.title && <h3>{c.title}</h3>}
                          {Array.isArray(c.text) ? 
                            <ul>
                              {c.text.map((t, index) => {
                                return <li key={index} dangerouslySetInnerHTML={{ __html: t }}></li>
                              })}
                            </ul> : 
                            <p dangerouslySetInnerHTML={{ __html: c.text }}></p>}
                        </div>
              })}
              <h2>Available Universal Life Carriers</h2>
              <Carriers productCarriers={props.carriers} category={props.category} isBasic />
            </Modal.Body>
        </Modal>
    )
}


// WEBPACK FOOTER //
// ./src/components/LandingPages/About/Common/ProductModal.js